import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSummaryProps } from '../@types/ProductSummaryProps';

export const ProductSummaryContext = createContext<ProductSummaryProps>({} as ProductSummaryProps);

ProductSummaryContext.displayName = 'ProductSummary';

const ProductSummaryProvider = (props: ProductSummaryProps) => (
	<ProductSummaryContext.Provider value={props}>{props.children}</ProductSummaryContext.Provider>
);

export const useProductSummary = () => {
	const context = useContext(ProductSummaryContext);

	return context;
};

export default ProductSummaryProvider;
